@if (tagData) {
  <div class="d-block" [ngStyle]="{ 'text-align': alignment }">
    <!-- FIELD TYPE -->
    @switch (fieldType) {
      <!-- FIELD TYPE :: TEXT BOX -->
      @case ("textbox") {
        <!-- TAG DATA INPUT TYPE -->
        @switch (tagData?.inputType) {
          <!-- TAG DATA INPUT TYPE :: NUMBER -->
          @case ("number") {
            <input
              [ngbTooltip]="tooltipNumberMsg"
              type="{{ tagData?.inputType }}"
              (keypress)="validateFieldLength(numberField)"
              maxlength="3"
              step="1"
              [min]="0"
              [max]="999"
              [formControl]="fieldName"
              #numberField
              (blur)="changeValue(numberField.value, tagData?.inputType)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: NUMBER2 -->
          @case ("number2") {
            <input
              [ngbTooltip]="tooltipNumberMsg"
              type="number"
              (keypress)="validateNumber2Length(numberField2)"
              maxlength="6"
              step="1"
              [min]="-999"
              [max]="999"
              [formControl]="fieldName"
              #numberField2
              (blur)="changeValue(numberField2.value, tagData?.inputType)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: TEXT -->
          @case ("text") {
            <input
              [ngbTooltip]="'Please enter only alphabet values'"
              type="{{ tagData?.inputType }}"
              alphabetOnly
              [formControl]="fieldName"
              #dyfield
              (blur)="changeValue(dyfield.value)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: EMAIL -->
          @case ("email") {
            <input
              [ngbTooltip]="'Please enter an email values'"
              type="{{ tagData?.inputType }}"
              emailOnly
              [formControl]="fieldName"
              #dyfield
              (blur)="changeValue(dyfield.value)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: TEL -->
          @case ("tel") {
            <input
              [ngbTooltip]="'Please enter the phone number'"
              type="{{ tagData?.inputType }}"
              mobNoMask
              [formControl]="fieldName"
              #dyfield
              (blur)="changeValue(dyfield.value)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: PASSWORD -->
          @case ("password") {
            <input
              [ngbTooltip]="'Please enter the password'"
              type="{{ tagData?.inputType }}"
              PasswordStrengthValidator
              [formControl]="fieldName"
              #dyfield
              (blur)="changeValue(dyfield.value)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: DUNS -->
          @case ("dunsNumber") {
            <input
              [ngbTooltip]="'Please enter the dunsNumber'"
              type="number"
              appNumberNegative
              [number_negative]="0"
              maxlength="3"
              [formControl]="fieldName"
              #dyfield
              (blur)="changeValue(dyfield.value)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: NAICS -->
          @case ("naics") {
            <input
              [ngbTooltip]="'Please enter the naics'"
              type="text"
              [formControl]="fieldName"
              #dyfield
              (blur)="changeValue(dyfield.value)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: CAGE -->
          @case ("cageCode") {
            <input
              [ngbTooltip]="'Please enter the CAGE Code'"
              type="text"
              [formControl]="fieldName"
              #dyfield
              (blur)="changeValue(dyfield.value)"
            />
          }
          <!-- TAG DATA INPUT TYPE :: DEFAULT -->
          @default {
            <input
              type="text"
              [formControl]="fieldName"
              #dyfield
              (blur)="changeValue(dyfield.value)"
            />
          }
        }
      }
      <!-- FIELD TYPE :: DATE -->
      @case ("date") {
        <input
          type="{{ fieldType }}"
          [min]="getDateRange().minDate"
          [max]="getDateRange().maxDate"
          [formControl]="fieldName"
          #dyfield
          (blur)="changeValue(dyfield.value)"
        />
      }
      <!-- FIELD TYPE :: TEXT AREA -->
      @case ("textarea") {
        @if (!tagData?.isHidden) {
          <textarea
            [formControl]="fieldName"
            #dyfield
            (blur)="changeValue(dyfield.value)"
          ></textarea>
        }
      }
      <!-- FIELD TYPE :: DEFAULT CASE-->
      @default {
        <input
          type="text"
          alphabetOnly
          [formControl]="fieldName"
          #dyfield
          (blur)="changeValue(dyfield.value)"
        />
      }
    }
  </div>
}
